const _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { createContext } from 'react';
import { jsx } from 'react/jsx-runtime';
const CMSContext = /*#__PURE__*/createContext({
  locale: 'en',
  onError: console.error,
  components: {}
});
function CMSProvider(_ref) {
  let children = _ref.children,
    options = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(CMSContext.Provider, {
    value: options,
    children: children
  });
}
export { CMSContext, CMSProvider };
//# sourceMappingURL=CMSProvider.js.map
